// extracted by mini-css-extract-plugin
export default {"top":"HeaderProducts_top__HyLx5","box":"HeaderProducts_box__qe9hX","addButton":"HeaderProducts_addButton__-yPAH"};